module.exports = __webpack_public_path__ + "static/img/arthroscopy-12.3d5f8dd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/arthroscopypic/arthroscopy-12.jpg
// module id = nyi3
// module chunks = 52